import { useState, useCallback, useEffect } from 'react';
import { EventData, EVENTS, STATUS, Step } from 'react-joyride';

const TOUR_KEY = 'solimat-record-detail-tour-v1';

const STEPS: Step[] = [
/*   {
    target: '.rd-hero',
    title: 'Resumen de la prestación',
    content: 'Esta cabecera muestra un resumen de tu prestación: el tipo de contingencia, número de expediente y las fechas de inicio y fin del proceso.',
    placement: 'bottom',
    skipBeacon: true,
  }, */
/*   {
    target: '.rd-hero__card',
    title: 'Ficha del expediente',
    content: 'Aquí se identifica el expediente con su código, el tipo de contingencia y si existe alguna causa de extinción del proceso.',
    placement: 'bottom',
    skipBeacon: true,
  }, */
 /*  {
    target: '.rd-hero__dates',
    title: 'Fechas del proceso',
    content: 'Las fechas de inicio y fin del proceso asistencial. Si el proceso sigue activo, la fecha de fin no estará disponible.',
    placement: 'bottom',
    skipBeacon: true,
  }, */
  {
    target: '.rd-section-head',
    title: 'Información asistencial',
    content: 'Accede a las distintas áreas de tu proceso: consultas, rehabilitación, quirófano, hospitalización y urgencias. Cada tarjeta muestra el número de sesiones, consultas y otros registros asistenciales relacionados con este área. Las tarjetas desactivadas indican que no hay registros para esa área.',
    placement: 'top',
    skipBeacon: true,
  },
  /* {
    target: '.record-detail-card_block',
    title: 'Tarjeta de área asistencial',
    content: 'Cada tarjeta muestra el número de sesiones, visitas u operaciones registradas en esa área. Las tarjetas desactivadas indican que no hay registros para esa área.',
    placement: 'right',
    skipBeacon: true,
  }, */
  {
    target: '.mgmt-tabs-card',
    title: 'Datos de Gestión',
    content: 'Consulta la información de administración, gestión económica y jurídica de tu prestación organizadas en pestañas.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.mgmt-tabs__bar',
    title: 'Pestañas de gestión',
    content: 'Navega entre las pestañas para consultar los datos administrativos, económicos y la información jurídica relacionada con tu prestación.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '[data-tour="rd-formularios"]',
    title: 'Formularios activos',
    content: 'Aquí aparecen los formularios relacionados con tu prestación activa. Puedes consultar su estado o agregar nuevos formularios.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '[data-tour="rd-formularios-add"]',
    title: 'Agregar formulario',
    content: 'Pulsa este botón para añadir un nuevo formulario a tu prestación activa. Se abrirá un panel con los formularios disponibles para que puedas seleccionar y cumplimentar el que necesites.',
    placement: 'left',
    skipBeacon: true,
  },
  {
    target: '.forms-pills',
    title: 'Filtros de formularios',
    content: 'Filtra los formularios por categoría usando estas etiquetas. Cada filtro muestra el número de formularios disponibles en esa categoría.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '[data-tour="rd-documentacion"]',
    title: 'Documentación General',
    content: 'Descarga los documentos y archivos asociados a tu prestación.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '[data-tour="rd-comentarios"]',
    title: 'Comentarios y comunicaciones',
    content: 'Consulta el historial de comunicaciones con Solimat relacionadas con esta prestación. Puedes añadir nuevos comentarios o adjuntar documentos si lo necesitas.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.comms-filters',
    title: 'Filtros de comentarios',
    content: 'Busca comentarios por texto o filtra por rango de fechas para localizar rápidamente una comunicación concreta.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.comms',
    title: 'Lista de comentarios',
    content: 'Aquí se muestran todos los mensajes e intercambios con Solimat. Haz clic en cualquier comentario para ver su contenido completo y los archivos adjuntos.',
    placement: 'top',
    skipBeacon: true,
  },
];

export const useRecordDetailTour = () => {
  const [run, setRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const handleCallback = useCallback((data: EventData) => {
    const { type, status, index } = data as any;
    const finished = status === STATUS.FINISHED || status === STATUS.SKIPPED;

    if (finished || (type as string) === EVENTS.TOUR_END) {
      setRun(false);
      localStorage.setItem(TOUR_KEY, 'true');
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }

    if ((type as string) === EVENTS.STEP_AFTER && index === 0) {
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }
  }, []);

  const startTour = useCallback(() => {
    setRun(current => {
      if (current) return false;
      setTourKey(k => k + 1);
      return true;
    });
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: run } }));
  }, [run]);

  return { run, tourKey, steps: STEPS, handleCallback, startTour };
};
